export const actionTypes = {
    CHAGE: 'CHANGE_NOTIFY'
}

export const changeNotify = (payLoad) =>({
    type: actionTypes.CHAGE,
    payLoad
})